import { Component, OnInit, AfterViewInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { Periodo } from '../util/periodo';
import { EstudoService } from '../estudo/estudo.service';
import { MatSnackBar } from '@angular/material';
import { EstudoRenovacao } from './estudo-renovacao';


@Component({
    templateUrl: './estudo-renovacao-list-filtro.component.html',
    selector: 'estudo-renovacao-list-filtro',
    styleUrls: [ './estudo-renovacao-list-filtro.component.css' ]
})
export class EstudoRenovacaoListFiltroComponent implements OnInit {

    public isLoading: boolean;

    public listaSituacao: Array<{id: number, denominacao: string}>;
    public filtro: EstudoRenovacao = new EstudoRenovacao();
    

    @Output() filtroEmitido: EventEmitter<EstudoRenovacao> = new EventEmitter<EstudoRenovacao>();
    // construtor
    constructor(private estudoService: EstudoService, private mensagem: MatSnackBar) {   }

    ngOnInit() {
      this.carregaSemestre();
      this.comboListaTipoResposta();
      // carrego quem não foi renovado por padrão
      this.filtro.renovado = false;
    }

    // emite o filtro
    public filtrar(): void {
      this.filtroEmitido.emit(this.filtro);
    }

    carregaSemestre() {
      this.estudoService.getPeriodoAtual().subscribe((periodo: Periodo[]) => {
        this.filtro.periodo = periodo[0].perPeriodo;
      },
        error =>  this.erro(error)
      );
    }

    comboListaTipoResposta() {
      this.listaSituacao = [
        {id: null, denominacao: '-Selecione-'},
        {id: 0, denominacao: 'Não Renovado'},
        {id: 1, denominacao: 'Renovado'}
      ];
    }

   // mostra erros na tela
   erro(erro: string) {
    this.mensagem.open(erro, 'X', {duration: 5000});
    this.isLoading = false;
  }

}
